import React, { FC } from "react";
import clsx from "clsx";

import { NavigationVideoTeachingMaterial } from "../../../../state";
import LessonVideo from "../LessonVideo";
import { ReactComponent as VolAccordionArrowIcon } from "../../../../assets/images/NavigationVideo/icon_vol_accordion_arrow.svg";

import styles from "./VolAccordion.module.scss";

type Props = {
  material: NavigationVideoTeachingMaterial;
  isOpen: boolean;
  onToggle: () => void;
  playingLessonVideoId: number | null;
  onVideoPlay: (videoId: number) => void;
};

const VolAccordion: FC<Props> = ({
  material,
  isOpen,
  onToggle,
  playingLessonVideoId,
  onVideoPlay,
}) => {
  const displayTitle = material.title.replace(/\s*-高校-|\s*-中学-/g, "");

  return (
    <div className={clsx(styles.accordion, isOpen && styles.isOpen)}>
      <button
        aria-expanded={isOpen}
        className={styles.accordionButton}
        onClick={onToggle}
        type="button"
      >
        <span className={styles.volTitle}>
          <span className={styles.volLabel}>{material.name}</span>
          {displayTitle}
        </span>
        <VolAccordionArrowIcon
          className={clsx(styles.accordionIcon, isOpen && styles.isOpen)}
        />
      </button>
      {isOpen && (
        <div className={styles.lessonList}>
          {material.lessons.map(lesson => (
            <LessonVideo
              isPlaying={playingLessonVideoId === lesson.id}
              key={lesson.id}
              lesson={lesson}
              onVideoPlay={onVideoPlay}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default VolAccordion;
